export default __webpack_public_path__ + "static/media/36I-102759_-37328_0.4d3ad70a.jpg";